import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    iconSection: {
        marginTop: '40px',
        marginBottom: '40px',
    },
    iconSuccess: {
        color: 'darkgreen',
        fontSize: 150
    },
    iconFailure: {
        color: 'darkred',
        fontSize: 150
    },
    textSection: {
        marginBottom: '10px',
        marginLeft: '10%',
        marginRight: '10%'
    },
    resendSection: {
        marginTop: 20,
        width: '75%',
        height: 180,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    button: {
        width: '75%',
    },
    footer: {
        marginTop: 'auto',
        marginBottom: '20px',
        width: '100%',
    },
}));

export default useStyles;